<template id="top-slide-wrap">
  <v-container class="pt-sm-8 slide-wrap fluid mt-md-8">
    <v-carousel cycle show-arrows-on-hover :interval="20000" class="responsive-carousel">
      <!-- <v-carousel-item
        v-for="(item, i) in images"
        :key="i"
        :src="item.src"
        :href="item.href"
        class="text-center bottom-gradient"
      >
        <div class="overlay-text" v-html="item.html"></div>
      </v-carousel-item> -->
      <v-carousel-item
  v-for="(item, i) in images"
  :key="i"
  class="text-center bottom-gradient slide-item"
  :class="item.bgClass"
  :style="item.style"
>
  <div class="hover-overlay"></div>
  <div class="overlay-text" v-html="item.html"></div>
</v-carousel-item>
    </v-carousel>
  </v-container>
</template>

<style>
.slide-wrap {
  max-width: 1200px;
  position: relative;
}

.overlay-text {
  position: absolute;
  top: 10%;
  left: 10%;
  /* transform: translate(-50%, -50%); */
  /* background-color: rgba(0, 0, 0, 0.5); */
  /* color: #fff; */
  padding: 20px;
  border-radius: 10px;
  max-width: 100%;
  text-align: left;
  letter-spacing: 0.45em;
}

.v-carousel-item {
  position: relative;
}
.cf-title {
    font-size: 2.8rem;
    color: #008ee6;
    border-bottom: 5px solid #dfdfdf;
    margin-bottom: 2rem;
    display: inline-block;
    font-family: "Roboto", sans-serif;
    font-weight: bold;
    margin:0 auto 5%;
    background: linear-gradient(90deg, #58c6ff 0%, #076ad9 40%, #004a83 80%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}
.cf-sub-title {
  padding-bottom:1rem;
  color: #666;
}

.cf-cnt {
  padding-bottom: 10px;
  letter-spacing: 0.3em;
  margin: 0 5px;
}

.cf-cnt-02 {
  margin-top: 2rem;
  color: #6c6c6c;
}

.slide-item {
  position: relative;
  overflow: hidden;
}

.hover-overlay {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background-color: rgba(0, 0, 0, 0); /* 最初は透明 */
  transition: background-color 0.3s ease;
  z-index: 1;
}

/* ホバー時に暗くする */
.slide-item:hover .hover-overlay {
  background-color: rgba(0, 0, 0, 0.1); /* 少し暗くなる */
}

/* overlay-text が hover-overlay の上に来るようにする */
.overlay-text {
  position: absolute;
  z-index: 2;
  /* 他の既存のスタイルはそのままでOK */
}

.hpm-title {
  color: #e7e702;
  padding-bottom: 1rem;
  font-size:2.5rem;
  letter-spacing: 0.3rem;
  /* background: #005589;
  padding: 30px; */
}

.hpm-title-cl {
  color: #fff;
  border-bottom: 5px solid #cecece;
}

.hpm-sub-title {
  color: #eeeeee;
  letter-spacing: 0.02rem;
  /* background: #005589; */
  /* padding: 30px; */
  max-width: 920px;
}

.slide-with-image {
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.hpm-cnt {
  color: #303030;
  margin-top:2rem;
  letter-spacing: 0.02rem;
}

.hpm-sub-title-cl {
  color:#ff9138;
  font-weight: bold;
  /* border-bottom: 3px solid #fd5d5d; */
}

.sys-sub-title {
  margin-top: 3rem;
}

.overlay-text {
  position: absolute;
  top: 10%;
  left: 5%;
  right: 5%;
  padding: 1rem;
  z-index: 2;
  text-align: left;
  letter-spacing: 0.1em;
  max-width: 90%;
  box-sizing: border-box;
}

.v-carousel-item {
  position: relative;
  min-height: 300px; /* 画面に応じて調整可能 */
}

.overlay-text h2,
.overlay-text h3,
.overlay-text div {
  word-break: break-word;
  overflow-wrap: break-word;
}

.cf-title-02 {
  font-size: 2rem;
}

@media (max-width: 850px) {
  .overlay-text {
    top: 5%;
    font-size: 0.9rem;
    padding: 0;
  }

  .cf-title {
    font-size: 1.3rem;
    margin-bottom: 0;
  }

  .hpm-title {
    font-size: 1.3rem;
  }

  .hpm-sub-title , .cf-sub-title {
    font-size: 0.9rem;
  }
  /* .slide-wrap {
   margin-top: -40px !important;
   padding-top:0 !important;
  } */
  .link-button {
    margin-top: 5px;
  }

  .v-carousel-item {
    min-height: 200px;
  }

  .cf-cnt-02 {
    margin-top: 1rem;
  }
  .responsive-carousel {
    height: 65vh!important;
    min-height: 200px;
  }
  .cf-sub-title {
    padding-bottom: 0;
  }
}

/* SEサイズスマホ */
@media (max-width: 380px) {
    .responsive-carousel {
      height: 70vh!important;
      min-height: 200px;
  }
}

@media (min-width:768px) and (max-width:820px) {
    .responsive-carousel {
      height: 30vh!important;
      min-height: 200px;
  }
}
</style>

<script>
export default {
  data: () => ({
    images: [
      {
        style: {
          backgroundImage: `url(${require('../../assets/Home/serviceSlide/blue_white.jpg')})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          background: 'linear-gradient(90deg,rgba(255, 255, 255, 1) 54%, rgba(223, 243, 247, 1) 84%, rgba(147, 228, 250, 1) 100%)',
          backgroundBlendMode: 'overlay'
        },
        bgClass: 'slide-with-image',
        src: require('../../assets/Home/serviceSlide/blue_white.jpg'),
        href: '/Service/supportConference',
        html: '<h2 class="mb-3 cf-title-02">学会ホームページ制作</h2>' +
          '<h2 class="cf-title">ページ数8頁、8カ月の更新サポート 7万8千円</h2>' +
          '<h3 class="cf-sub-title">多くの医療関係の学会のホームページを制作、運用してきた経験から学会のホームページを低コストに作成、運用を行います。</h3>' +
          '<div>' +
          '<a href=\'/Service/supportConference\' target="_blank" class="link-button cf-cnt" @click.stop>学会ホームページ制作</a>' +
          '<a href=\'/Products/registration\' target="_blank" class="link-button cf-cnt" @click.stop>演題登録システム</a>' +
          '<a href=\'/Products/participation\' target="_blank" class="link-button cf-cnt" @click.stop>事前参加システム</a>' +
          '</div>' +
          '<h4 class="cf-cnt-02">ハイブリッド会議等にも対応いたします。学会の規模に合わせてカスタムいたしますので、ご要望ご相談ください。</div>'
      },
      {
        style: {
          backgroundColor: '#ececec',
          color: 'black',
          background: ' linear-gradient(90deg,rgba(178, 199, 217, 1) 0%, rgba(180, 210, 222, 1) 12%, rgba(255, 255, 255, 1) 41%)',
          backgroundBlendMode: 'overlay'
        },
        bgClass: 'slide-bg-color-only', // このスライドだけ画像なし
        href: '/',
        html: '<h2 class="cf-title-02"><span class="cf-title">研究開発</span></h2><h3 class="cf-sub-title">※準備中</h3>'
      },
      {
        style: {
          // backgroundColor: '#ececec',
          color: 'white',
          backgroundImage: `url(${require('../../assets/Home/serviceSlide/konniesystem-top01.jpg')})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          // backgroundColor: '#2e403e',
          backgroundColor: '#4f585c',
          backgroundBlendMode: 'overlay'
        },
        bgClass: 'slide-with-image', // このスライドだけ画像なし
        href: '/',
        src: require('../../assets/Home/serviceSlide/blue_white.jpg'),
        html: '<h2 class="hpm-title">WordPress、Joomlaのアップデート<br><span class="hpm-title-cl">CMSを利用したホームページの保守</span></h2><h3 class="hpm-sub-title">WordPress,Joomla等のオープンソースのCMSをサポート期限の切れたままホームページを公開し続けることはセキュリティリスクを伴いますので、最新バージョンで運用することが必要です。</h3><h3 class="hpm-sub-title mt-3">その他、<span class="hpm-sub-title-cl">エラー対応、サイト移行、セキュリティ対応等、保守運用</span>についてお困りのことありましたら、お問合せください。</div><br><br><a href=\'https://konniesystem.co.jp/hp_maintenance/#hpm_example\' target="_blank" class="link-button cf-cnt" @click.stop>詳しくは、こちら</a>'
      },
      {
        style: {
          // backgroundColor: '#ececec',
          color: '#333',
          backgroundImage: `url(${require('../../assets/Home/serviceSlide/it_background.jpg')})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          backgroundColor: '#555',
          backgroundBlendMode: 'overlay'
        },
        bgClass: 'slide-with-image', // このスライドだけ画像なし
        href: '/',
        html: '<h2 class="hpm-title"><span class="hpm-title-cl">システム保守</span><br></h2><h3 class="hpm-sub-title mt-5">システムの運用保守でお困りのことあればご相談ください。 </h3><h3 class="hpm-sub-title mt-3">その他、<span class="hpm-sub-title-cl">エラー対応、セキュリティ対応等、保守運用</span>についてお困りのことありましたら、お問合せください。</div><br><br><a href=\'/Service/Maintenance\' target="_blank" class="link-button cf-cnt link-btn-sys" @click.stop>詳しくは、こちら</a>'
      }
    ]
  })
}
</script>
